import { PermissionsAndroid } from 'react-native';
import { usePermission } from './usePermission';

const permission = PermissionsAndroid.PERMISSIONS.RECORD_AUDIO;

export const useMicrophonePermission = () => {
  return usePermission({
    permission,
    rationale: {
      title: 'Microphone Permission',
      message: 'To chat with Pixi, you need to enable your microphone',
      buttonNegative: 'Cancel',
      buttonPositive: 'OK',
    },
  });
};
